import { connect } from 'react-redux'
import requestRemoveCardFromMyBoard from '../../../sagas/requestRemoveCardFromMyBoard'
import requestAddCardTemplate from '../../../sagas/requestAddCardTemplate'
import requestAddCardToMyBoard from '../../../sagas/requestAddCardToMyBoard'
import requestArchiveCard from '../../../sagas/requestArchiveCard'
import requestCopyCard from '../../../sagas/requestCopyCard'
import requestDeleteCard from '../../../sagas/requestDeleteCard'
import requestFollowCard from '../../../sagas/requestFollowCard'
import requestMoveCard from '../../../sagas/requestMoveCard'
import moreActionsSelector from './moreActionsSelector'
import MoreActions from './MoreActions'
import { withBoardContext } from 'dataProviders/Board'

export default withBoardContext(connect(
  moreActionsSelector,
  {
    requestMoveCard,
    requestCopyCard,
    requestAddCardTemplate,
    requestArchiveCard,
    requestDeleteCard,
    requestAddCardToMyBoard,
    requestRemoveCardFromMyBoard,
    requestFollowCard
  }
)(MoreActions))
